<template>
  <!--公司简介-->
  <section id="aboutus">
    <div class="caption caption-white">
      <h1>公司简介</h1>
      <div class="caption-sub middle">
        <div class="flex"></div>
        <span>PROFILE</span>
        <div class="flex"></div>
      </div>
    </div>

    <div class="bg">
      <div class="bg-img" ref="bgImg" id="bgImg"></div>
    </div>

    <div class="aboutus">
      <router-link to="/aboutus/profile">
        <div class="mycard" ref="myCard1">
          <div class="body">
            <img src="../../assets/images/index/aboutus-1.png" />
            <h2>简介</h2>
            <span>Profile</span>
            <p>
              公司成立于2018年，注册资本1000万。公司致力于将景区的科技与文化相融合，建立智慧化的数字文化内容体系
            </p>
          </div>
          <div class="foot"></div>
        </div>
      </router-link>
      <router-link to="/aboutus/qualification">
        <div class="mycard" ref="myCard2">
          <div class="body">
            <img src="../../assets/images/index/aboutus-2.png" />
            <h2>资质</h2>
            <span>Qualification</span>
            <p>
              企业资质就是企业在从事某种行业经营中，应具有的资格以及与此资格相适应的质量等级标准
            </p>
          </div>
          <div class="foot"></div>
        </div>
      </router-link>
      <a>
        <div class="mycard" ref="myCard3">
          <div class="body">
            <img src="../../assets/images/index/aboutus-3.png" />
            <h2>顾问团队</h2>
            <span>Team</span>
            <p>
              团队是指拥有共同目标，并且具有不同能力的一小群人有意识的协调行为或力的系统，是一种应用广泛
            </p>
          </div>
          <div class="foot"></div>
        </div>
      </a>
      <router-link to="/aboutus/recruit">
        <div class="mycard" ref="myCard4">
          <div class="body">
            <img src="../../assets/images/index/aboutus-4.png" />
            <h2>招聘</h2>
            <span>Recruitment</span>
            <p>
              崇尚“业绩导向”，倡导学习、创新、团队意识和价值创造
            </p>
          </div>
          <div class="foot"></div>
        </div>
      </router-link>
    </div>
  </section>
</template>

<script>
import play from "./play";

export default {
  mounted() {
    play(
      [
        this.$refs.myCard1,
        this.$refs.myCard2,
        this.$refs.myCard3,
        this.$refs.myCard4
      ],
      "anm-fadeInUp"
    );
    play([this.$refs.bgImg], "anm-aboutus-bg");
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/styles/common.scss";
@import "../../assets/styles/animate.css";

section#aboutus {
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;

  > .bg {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    z-index: -1;
    overflow: hidden;

    > .bg-img {
      background: url(../../assets/images/index/aboutus-bg.png) no-repeat center;
      width: 100%;
      height: 100%;
      transform: scale(1.2);
    }

    .anm-aboutus-bg {
      animation: anm_aboutus_bg 5s linear;
    }

    @keyframes anm_aboutus_bg {
      0% {
        opacity: 0.8;
        transform: scale(1);
      }
      100% {
        transform: scale(1.2);
      }
    }
  }

  > .aboutus {
    display: flex;
    justify-content: space-between;
    padding-left: 0;
    width: $SIZE_PAGE_WIDTH;
    // clear: both;
    margin-bottom: 5vw;

    > a,
    a:hover {
      text-decoration: none;
      color: #ffffff;
      text-decoration: none;
      color: rgb(248, 248, 248);

      > .mycard {
        display: flex;
        flex-direction: column;
        align-items: center;
        float: left;
        flex-grow: 1;
        padding: 5vw 2vw;
        width: ($SIZE_PAGE_WIDTH - 2vw * 3) / 4;
        height: 65vh;
        line-height: 20px;
        color: rgb(248, 248, 248);

        > .body {
          flex-grow: 1;
          display: flex;
          flex-direction: column;
          align-items: center;
          height: 50vh;

          img {
            width: 110px;
            height: 110px;
          }
          h2 {
            font-size: 0.08rem;
            padding-top: 15px;
            margin-bottom: 20px;
          }
          span {
            font-size: 0.05rem;
            font-weight: lighter;
          }
          p {
            // font-weight: 500;
            font-size: 0.06rem;
            text-align: center;
            opacity: 0.85;
            margin: 20px 0 0 0;
            height: 20vh;
          }
        }

        > .foot {
          width: 5vw;
          height: 0.4vh;
          // background-color: white;
          // margin: 5vh (($SIZE_PAGE_WIDTH - 2vw * 3) / 4 - 8vw) / 2;
          border: 2px solid white;
          margin: 1vh 0;
        }

        &:hover {
          background: #00060afb;
          opacity: 0.8;
          border-bottom: 1px solid #000;
        }
      }
    }
  }
}

@keyframes wrapper-gradient {
  0% {
    transform: translateY(80%);
  }

  100% {
    transform: translateY(0);
  }
}

@keyframes img-gradient {
  0% {
    transform: translateY(0);
  }

  100% {
    transform: translateY(100%);
  }
}

.anm-fadeInUp {
  animation: fadeInUp 3s;
  //   animation-fill-mode: forwards;
}
</style>